// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type ServerGroupMembersQueryVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
  serverGroupId?: Types.InputMaybe<Types.Scalars["ID"]["input"]>;
  matchRules?: Types.InputMaybe<
    Array<Types.ServerGroupMatchRuleInput> | Types.ServerGroupMatchRuleInput
  >;
}>;

export type ServerGroupMembersQuery = {
  __typename?: "GraphqlQuery";
  getServerGroupMembers: Array<{
    __typename?: "ServerGroupMember";
    id: string;
    name: string;
  }>;
};

export const ServerGroupMembersDocument = gql`
  query ServerGroupMembers(
    $organizationSlug: ID!
    $serverGroupId: ID
    $matchRules: [ServerGroupMatchRuleInput!]
  ) {
    getServerGroupMembers(
      organizationSlug: $organizationSlug
      serverGroupId: $serverGroupId
      matchRules: $matchRules
    ) {
      id
      name
    }
  }
`;

/**
 * __useServerGroupMembersQuery__
 *
 * To run a query within a React component, call `useServerGroupMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useServerGroupMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServerGroupMembersQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *      serverGroupId: // value for 'serverGroupId'
 *      matchRules: // value for 'matchRules'
 *   },
 * });
 */
export function useServerGroupMembersQuery(
  baseOptions: Apollo.QueryHookOptions<
    ServerGroupMembersQuery,
    ServerGroupMembersQueryVariables
  > &
    (
      | { variables: ServerGroupMembersQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ServerGroupMembersQuery,
    ServerGroupMembersQueryVariables
  >(ServerGroupMembersDocument, options);
}
export function useServerGroupMembersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ServerGroupMembersQuery,
    ServerGroupMembersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ServerGroupMembersQuery,
    ServerGroupMembersQueryVariables
  >(ServerGroupMembersDocument, options);
}
// @ts-ignore
export function useServerGroupMembersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ServerGroupMembersQuery,
    ServerGroupMembersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ServerGroupMembersQuery,
  ServerGroupMembersQueryVariables
>;
export function useServerGroupMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServerGroupMembersQuery,
        ServerGroupMembersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ServerGroupMembersQuery | undefined,
  ServerGroupMembersQueryVariables
>;
export function useServerGroupMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServerGroupMembersQuery,
        ServerGroupMembersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ServerGroupMembersQuery,
    ServerGroupMembersQueryVariables
  >(ServerGroupMembersDocument, options);
}
export type ServerGroupMembersQueryHookResult = ReturnType<
  typeof useServerGroupMembersQuery
>;
export type ServerGroupMembersLazyQueryHookResult = ReturnType<
  typeof useServerGroupMembersLazyQuery
>;
export type ServerGroupMembersSuspenseQueryHookResult = ReturnType<
  typeof useServerGroupMembersSuspenseQuery
>;
export type ServerGroupMembersQueryResult = Apollo.QueryResult<
  ServerGroupMembersQuery,
  ServerGroupMembersQueryVariables
>;
